import axios from 'axios';

const api = axios.create({
    timeout: 800000000,
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

export default api;